<template>
  <div class="row">
    <modal :show.sync="modals.lights" type="medium">
      <template slot="header">
        <h3 class="modal-title" id="exampleModalLabel">List of Lights</h3>
      </template>
      <div>
        <card card-body-classes="table-full-width">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search Device"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input>
            </div>
            <el-table
              :data="
                queriedData.filter(
                  (data) =>
                    !searchQuery ||
                    data.deviceName
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase())
                )
              "
              :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
            >
              <el-table-column
                :min-width="150"
                prop="deviceName"
                label="Device Name"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="status"
                label="Status"
              ></el-table-column>
              <el-table-column v-if="false" prop="deviceID"></el-table-column>
              <el-table-column :min-width="150">
                <template slot-scope="scope">
                  <base-button
                    type="success"
                    @click="viewDevice(scope.row.deviceID, 'nodestl')"
                    >Go to Light</base-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </modal>
    <modal :show.sync="modals.logs" type="large">
      <template slot="header">
        <h3 class="modal-title" id="exampleModalLabel">Cluster logs data</h3>
      </template>
      <div>
        <card card-body-classes="table-full-width">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <!-- <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search Device"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input> -->
            </div>
            <el-table
              :data="queriedData"
              :header-cell-style="{
                background: 'transparent  ',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
            >
              <el-table-column
                :min-width="150"
                prop="eventtime"
                label="Event time"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="context"
                label="Context"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="message"
                label="Message"
              ></el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </modal>
    <modal
      :show.sync="modals.viewlargermap"
      type="xxl"
      headerClasses="justify-content-center"
      :preventClose="true"
    >
      <!-- <template slot="header">
        <h3 class="modal-title" id="exampleModalLabel">List of Lights</h3>
      </template> -->
      <div id="map" class="map" style="height: 600px">
        <l-map
          ref="map"
          id="toto"
          :height="650"
          :zoom="16"
          :center="center"
          :maxZoom="19"
          :minZoom="15"
          :bounds="largerview"
          class="sidebar-map"
        >
          <!-- :max-bounds="largerview" -->
          <!-- :bounds="devBounds" -->
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-control position="bottomleft">
            <div id="legend">
              <b style="font-size: 12px">Legend</b>
              <div class="legend_attr">
                <img src="img\light_online_on.png" style="width: 16px" />
                Lights Online | ON ({{ countonlineon }})
              </div>
              <div class="legend_attr">
                <img src="img\light_online_off.png" style="width: 16px" />
                Lights Online | OFF ({{ countonlineoff }})
              </div>
              <!-- <div class="legend_attr">
                              <img
                                src="img\light_online_notfollow.png"
                                style="width: 16px"
                              />
                              Lights not follow schedule
                            </div> -->
              <div class="legend_attr">
                <img src="img\light_offline.png" style="width: 16px" />
                Lights Offline ({{ countoffline11 }})
              </div>
              <div class="legend_attr">
                <img src="img\feeder_pillar.png" style="width: 16px" />
                Feeder Pillar
              </div>
              <div class="legend_attr">
                <img src="img\gw_online.png" style="width: 16px" />
                Gateways | Online ({{ GatewayOnlineCount }})
              </div>
              <div class="legend_attr">
                <img src="img\gw_offline.png" style="width: 16px" />
                Gateways | Offline ({{ GatewayOfflineCount }})
              </div>
              <div class="legend_attr">
                <img src="img\LUX map icon online.png" style="width: 16px" />
                Lux Online
              </div>
              <div class="legend_attr">
                <img src="img\lux map icon offline.png" style="width: 16px" />
                Lux Offline
              </div>
            </div>
          </l-control>
          <l-control position="topright">
            <!-- style="background-color: #ffffff; border-radius: 5px;" -->
            <div>
              <base-button
                class="btn-icon"
                style="color: #000000; background: #ffffff !important"
                @click="modals.viewlargermap = false"
                ><i class="fa fa-compress" aria-hidden="true"></i
              ></base-button>
            </div>
          </l-control>

          <l-layer-group layer-type="overlay" name="Layer 1">
            <l-marker
              v-for="marker in markerss"
              :icon="
                markerIcon(marker.operationalStat, marker.status, 'DEVICE')
              "
              :key="marker.addMarker"
              :lat-lng="marker.location"
              ref="markersRef"
              @click="
                viewDevice(marker.deviceID, marker.flag, marker.deviceToken)
              "
            >
              <l-tooltip :content="marker.deviceName" />
            </l-marker>
          </l-layer-group>
          <l-layer-group layer-type="overlay" name="Feeder">
            <l-marker
              v-for="marker in fpmarkerss"
              :icon="markerIcon('', '', 'FEEDER')"
              :key="marker.addMarker"
              :lat-lng="marker.fploc"
              ref="markersRef"
            >
              <l-tooltip :content="marker.fpname" />
            </l-marker>
          </l-layer-group>
          <l-layer-group layer-type="overlay" name="Gateway">
            <l-marker
              v-for="marker in gwmarkerss"
              :icon="markerIcon(marker.status, '', 'GATEWAY')"
              :key="marker.addMarker"
              :lat-lng="marker.gwloc"
              ref="markersRef"
            >
              <l-tooltip :content="marker.gwname" />
            </l-marker>
          </l-layer-group>
          <l-layer-group layer-type="overlay" name="Lux">
            <l-marker
              v-for="marker in luxmarkerss"
              :icon="markerIcon(marker.status, '', 'LUX')"
              :key="marker.addMarker"
              :lat-lng="marker.location"
              ref="markersRef"
              @click="
                viewDevice(marker.deviceID, marker.flag, marker.deviceToken)
              "
            >
              <l-tooltip :content="marker.deviceName" />
            </l-marker>
          </l-layer-group>
        </l-map>
      </div>
    </modal>
    <div class="col-lg-8 col-xs-6">
      <h3 style="margin-bottom: 15px"></h3>
    </div>
    <div class="col-lg-4 col-xs-3 text-center text-md-right">
      <base-dropdown
        menu-classes="dropdown-black"
        title-classes="btn btn-secondary"
        title="More Information"
        menuOnRight
        style="z-index: 1001"
      >
        <a
          class="dropdown-item"
          style="color: white"
          @click="viewDataAnalytic(clusterID)"
          >Data Analytic</a
        >
        <!-- <router-link to="/dataanalytic"> -->
        <a
          @click="getClusterDevice(clusterID, true)"
          class="dropdown-item"
          style="color: white"
          >List of Lights</a
        >
        <a @click="getClusterLogs()" class="dropdown-item" style="color: white"
          >Cluster logs</a
        >
        <a
          @click="LightControlNew('RTC', '1', clusterToken)"
          class="dropdown-item"
          style="color: white"
          >Push RTC Downlink</a
        >
        <!-- </router-link> -->
      </base-dropdown>
      <!-- <base-button simple type="success" @click="viewDataAnalytic(clusterID)"
        >Data Analytic</base-button
      >&nbsp;
      <base-button simple type="info" @click="getClusterDevice(clusterID, true)"
        >List of Lights</base-button
      >&nbsp;
      <base-button simple type="info" @click="getClusterLogs()"
        >Cluster logs</base-button
      > -->
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg-12">
              <!-- Cluster name -->
              <div class="row">
                <div class="col-lg il">
                  <h3 class="analytic">Cluster Name: {{ clusterName }}</h3>
                  <hr />
                </div>
              </div>
            </div>
            <card type="card-chart" style="height: 360px">
              <template>
                <div class="row" style="padding: 15px">
                  <!-- Brightness Level -->
                  <div class="col-lg-12 col-md-12 inlineControl">
                    <div class="row">
                      <div class="col-lg-12 brightness">
                        <veeno
                          class="slider-success"
                          v-model="clusterBrightness"
                          behaviour="none"
                          :handles="10"
                          :range="{ min: 10, max: 100 }"
                          :step="10"
                          :disabled="disabledBtn"
                        />
                        <br />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <h5 class="card-category">Brightness Level</h5>
                    <h3 class="card-title brightness">
                      <div class="row">
                        <div class="col-lg-12 brightness">
                          <p>{{ clusterBrightness }}%</p>
                        </div>
                      </div>
                    </h3>
                  </div>
                  <!-- Override scheduler -->
                  <div class="col-lg-4 col-md-4 inlineControl">
                    <p
                      v-show="active1"
                      style="color: #ffd600; font-size: 10.5px"
                    >
                      {{ overrideMsg }}
                    </p>
                    <h5 class="card-category">Override Scheduler</h5>
                    <h3 class="card-title brightness">
                      <div
                        @mouseover="active = true"
                        @mouseout="active = false"
                      >
                        <el-select
                          class="select-primary"
                          size="large"
                          placeholder="Choose"
                          v-model="selects.simple"
                          @change="handleClusterOverride(selects.simple)"
                          :disabled="disabledDropDown"
                        >
                          <el-option
                            v-for="option in selects.time"
                            class="select-primary"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></el-option>
                        </el-select>
                      </div>
                    </h3>
                    <div slot="footer"></div>
                  </div>

                  <!-- On/Off button -->
                  <div class="col-lg-6 col-md-6 inlineControl">
                    <h5 class="card-category">Node Control</h5>
                    <h3 class="card-title brightness">
                      <base-button
                        :disabled="disabledBtn"
                        type="primary"
                        v-on:click="
                          LightControlNew('POWER', 'ON', clusterToken)
                        "
                        ><i v-show="onSpin" class="fas fa-spinner fa-spin"></i>
                        &nbsp;{{ btnOnMsg }}</base-button
                      >&nbsp;
                      <base-button
                        :disabled="disabledBtn"
                        type="danger"
                        v-on:click="
                          LightControlNew('POWER', 'OFF', clusterToken)
                        "
                        ><i v-show="OffSpin" class="fas fa-spinner fa-spin"></i>
                        &nbsp;{{ btnOffMsg }}</base-button
                      >
                      <div slot="footer"></div>
                    </h3>
                  </div>
                </div>
              </template>
            </card>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="row">
            <!-- Total Lights -->
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12 il">
                  <h3 class="analytic">Total Lights: {{ totalLight }}</h3>
                  <hr />
                </div>
              </div>
            </div>

            <!-- Map -->
            <div class="col-lg-12">
              <card type="chart" style="height: 360px">
                <loading
                  loader="spinner"
                  :height="70"
                  :width="70"
                  color="#00f2c3"
                  background-color="#6c757d"
                  transition="fade"
                  :active="isLoading"
                  :is-full-page="false"
                ></loading>
                <template slot="header">
                  <h5 class="card-category">
                    <b>Last hourly update: {{ get30Min() }}</b>
                  </h5>
                  <h3 class="card-title">
                    <!-- map -->
                    <div id="map" class="map">
                      <l-map
                        v-model="center"
                        ref="map"
                        id="toto"
                        style="height: 295px"
                        :zoom="zoom"
                        :center="center"
                        :bounds="devBounds"
                        class="sidebar-map"
                        :options="{ scrollWheelZoom: false }"
                      >
                        <!-- :bounds="devBounds" -->
                        <l-tile-layer
                          :url="url"
                          :attribution="attribution"
                        ></l-tile-layer>
                        <l-control position="bottomleft">
                          <div id="legend">
                            <div class="row">
                              <div class="col-lg text-left">
                                <b style="font-size: 12px">Legend</b>
                              </div>
                              <div
                                class="col-lg text-right"
                                v-if="view == true"
                              >
                                <p style="color: grey" @click="view = false">
                                  <i
                                    style="
                                      font-size: 8px;
                                      border: 1px solid grey;
                                      padding: 2px;
                                    "
                                    class="fa fa-minus"
                                    aria-hidden="true"
                                  ></i>
                                </p>
                              </div>
                              <div
                                class="col-lg text-right"
                                v-if="view == false"
                              >
                                <p style="color: grey" @click="view = true">
                                  <i
                                    style="
                                      font-size: 8px;
                                      border: 1px solid grey;
                                      padding: 2px;
                                    "
                                    class="fa fa-plus"
                                    aria-hidden="true"
                                  ></i>
                                </p>
                              </div>
                            </div>
                            <div v-if="view == true">
                              <div class="legend_attr">
                                <img
                                  src="img\light_online_on.png"
                                  style="width: 16px"
                                />
                                Lights Online | ON ({{ countonlineon }})
                              </div>
                              <div class="legend_attr">
                                <img
                                  src="img\light_online_off.png"
                                  style="width: 16px"
                                />
                                Lights Online | OFF ({{ countonlineoff }})
                              </div>
                              <!-- <div class="legend_attr">
                              <img
                                src="img\light_online_notfollow.png"
                                style="width: 16px"
                              />
                              Lights not follow schedule
                            </div> -->
                              <div class="legend_attr">
                                <img
                                  src="img\light_offline.png"
                                  style="width: 16px"
                                />
                                Lights Offline ({{ countoffline11 }})
                              </div>
                              <div class="legend_attr">
                                <img
                                  src="img\feeder_pillar.png"
                                  style="width: 16px"
                                />
                                Feeder Pillar
                              </div>
                              <div class="legend_attr">
                                <img
                                  src="img\gw_online.png"
                                  style="width: 16px"
                                />
                                Gateways | Online ({{ GatewayOnlineCount }})
                              </div>
                              <div class="legend_attr">
                                <img
                                  src="img\gw_offline.png"
                                  style="width: 16px"
                                />
                                Gateways | Offline ({{ GatewayOfflineCount }})
                              </div>
                              <div class="legend_attr">
                                <img
                                  src="img\LUX map icon online.png"
                                  style="width: 16px"
                                />
                                Lux Online
                              </div>
                              <div class="legend_attr">
                                <img
                                  src="img\lux map icon offline.png"
                                  style="width: 16px"
                                />
                                Lux Offline
                              </div>
                            </div>
                          </div>
                        </l-control>
                        <l-control position="topright">
                          <!-- style="background-color: #ffffff; border-radius: 5px;" -->
                          <div>
                            <base-button
                              class="btn-icon"
                              style="
                                color: #000000;
                                background: #ffffff !important;
                              "
                              @click="openlargermap()"
                              ><i class="fa fa-expand" aria-hidden="true"></i
                            ></base-button>
                          </div>
                        </l-control>

                        <l-layer-group layer-type="overlay" name="Layer 1">
                          <l-marker
                            v-for="marker in markers"
                            :icon="
                              markerIcon(
                                marker.operationalStat,
                                marker.status,
                                'DEVICE'
                              )
                            "
                            :key="marker.addMarker"
                            :lat-lng="marker.location"
                            ref="markersRef"
                            @click="
                              viewDevice(
                                marker.deviceID,
                                marker.flag,
                                marker.deviceToken
                              )
                            "
                          >
                            <l-tooltip :content="marker.deviceName" />
                          </l-marker>
                        </l-layer-group>
                        <l-layer-group layer-type="overlay" name="Feeder">
                          <l-marker
                            v-for="marker in fpmarkers"
                            :icon="markerIcon('', '', 'FEEDER')"
                            :key="marker.addMarker"
                            :lat-lng="marker.fploc"
                            ref="markersRef"
                          >
                            <l-tooltip :content="marker.fpname" />
                          </l-marker>
                        </l-layer-group>
                        <l-layer-group layer-type="overlay" name="Gateway">
                          <l-marker
                            v-for="marker in gwmarkers"
                            :icon="markerIcon(marker.status, '', 'GATEWAY')"
                            :key="marker.addMarker"
                            :lat-lng="marker.gwloc"
                            ref="markersRef"
                          >
                            <l-tooltip :content="marker.gwname" />
                          </l-marker>
                        </l-layer-group>
                        <l-layer-group layer-type="overlay" name="Lux">
                          <l-marker
                            v-for="marker in luxmarkers"
                            :icon="markerIcon(marker.status, '', 'LUX')"
                            :key="marker.addMarker"
                            :lat-lng="marker.location"
                            ref="markersRef"
                            @click="
                              viewDevice(
                                marker.deviceID,
                                marker.flag,
                                marker.deviceToken
                              )
                            "
                          >
                            <l-tooltip :content="marker.deviceName" />
                          </l-marker>
                        </l-layer-group>
                      </l-map>
                    </div>
                  </h3>
                  <div slot="footer"></div>
                </template>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-xl-6 col-lg-12">
          <div class="row">
            <!-- Total Cost -->
            <div class="col-lg-6">
              <stats-card
                message="This value calculated based on schedule for the last 7 days."
                customClass="fa fa-info-circle"
                :title="totalCost"
                :sub-title="costTitle"
                :icon="costIcon"
                style="height: 100px"
              ></stats-card>
            </div>

            <!-- Total Energy -->
            <div class="col-lg-6">
              <stats-card
                message="This value calculated based on schedule for the last 7 days."
                customClass="fa fa-info-circle"
                :title="totalEnergy"
                :sub-title="energyTitle"
                :icon="energyIcon"
                style="height: 100px"
              ></stats-card>
            </div>

            <!-- Operational Lights -->
            <div class="col-lg-6">
              <stats-card
                customClass=""
                :title="operationalLights"
                :sub-title="opLightsTitle"
                :icon="opLightsIcon"
                style="height: 100px"
              ></stats-card>
            </div>

            <!-- Cluster Status -->
            <div class="col-lg-6">
              <stats-card
                customClass=""
                :title="clusterStatus"
                :sub-title="clusterStatusTitle"
                :icon="clusterStatusIcon"
                style="height: 100px"
              ></stats-card>
            </div>

            <!-- Brightness Level -->
            <div class="col-lg-4">
              <stats-card
                customClass=""
                :title="clusterBrightnessShow"
                :sub-title="clusterBrightnessTitle"
                :icon="clusterBrightnessIcon"
                style="height: 100px"
              ></stats-card>
            </div>

            <!-- Comm Uprate -->
            <div class="col-lg-4">
              <stats-card
                customClass=""
                :title="commUprate"
                :sub-title="commUprateTitle"
                :icon="commUprateIcon"
                style="height: 100px"
              ></stats-card>
            </div>

            <!-- scheduler profile -->
            <div class="col-lg-4">
              <stats-card
                customClass=""
                :title="schedulerProfile"
                :sub-title="schedulerProfileTitle"
                :icon="schedulerProfileIcon"
                style="height: 100px"
              ></stats-card>
            </div>
          </div>
        </div>
        <!-- Voltage -->
        <div class="col-lg-6 col-md-6">
          <card type="card-chart" style="height: 360px">
            <template slot="header">
              <h5 class="card-category">
                Voltage (V) (Daily Data generated at : {{ lastUpdate.date }})
              </h5>

              <h3 class="card-title">
                <!-- chart -->
                <div class="chart-area">
                  <line-chart
                    v-if="lineChart1.loaded"
                    :chart-data="lineChart1.chartData"
                    :gradient-colors="lineChart1.gradientColors"
                    :gradient-stops="lineChart1.gradientStops"
                    :extra-options="lineChart1.extraOptions"
                    :height="250"
                  ></line-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>

        <!-- Current -->
        <div class="col-lg-6 col-md-6">
          <card type="card-chart">
            <template slot="header">
              <h5 class="card-category">
                Current (A) (Daily Data generated at : {{ lastUpdate.date }})
              </h5>
              <h3 class="card-title">
                <!-- chart -->
                <div class="chart-area">
                  <line-chart
                    v-if="lineChart2.loaded"
                    :chart-data="lineChart2.chartData"
                    :gradient-colors="lineChart2.gradientColors"
                    :gradient-stops="lineChart2.gradientStops"
                    :extra-options="lineChart2.extraOptions"
                    :height="250"
                  ></line-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>

        <!-- Energy & Cost -->
        <div class="col-lg-6 col-md-6 d-flex">
          <card type="card-chart">
            <template slot="header">
              <h5 class="card-category">
                Energy (kWh) (Daily Data generated at : {{ lastUpdate.date }})
              </h5>
              <h3 class="card-title">
                <!-- chart -->
                <div class="chart-area">
                  <line-chart
                    v-if="lineChart3.loaded"
                    :chart-data="lineChart3.chartData"
                    :gradient-colors="lineChart3.gradientColors"
                    :gradient-stops="lineChart3.gradientStops"
                    :extra-options="lineChart3.extraOptions"
                    :height="250"
                  ></line-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>

        <!-- Brightness Control-->
        <div class="col-lg-6 col-md-6 d-flex"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import LineChart from "@/components/Charts/LineChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import moment from "moment";
import { extendMoment } from "moment-range";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
  LLayerGroup,
  LTooltip,
  LControl,
} from "vue2-leaflet";
import { latLngBounds, latLng } from "leaflet";
import { Slider, BaseSwitch } from "src/components/index";
import swal from "sweetalert2";
import { Table, TableColumn } from "element-ui";
import StatsCard from "src/components/Cards/StatsCard";
import { Modal, BasePagination } from "src/components";
import veeno from "veeno";
import Fuse from "fuse.js";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading,
    [Option.name]: Option,
    [Select.name]: Select,
    LineChart,
    LMap,
    LTileLayer,
    LMarker,
    LLayerGroup,
    LPopup,
    LControl,
    LTooltip,
    Slider,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    StatsCard,
    veeno,
    Modal,
    BasePagination,
    extendMoment,
  },
  data() {
    return {
      countonlineoff: 0,
      countonlineon: 0,
      GatewayOnlineCount: 0,
      GatewayOfflineCount: 0,
      countoffline10: 0,
      countoffline11: 0,
      view: false,
      overrideMsg: null,
      isLoading: false,
      //cluster info
      clusterTariff: null,
      clusterOldSon: null,
      //
      clusterFullData: null,
      tempMarker: [],
      modals: {
        lights: false,
        logs: false,
        viewlargermap: false,
      },
      //totalLightOn
      totalLightOn: 0,
      //control
      btnOnMsg: "Turn On",
      btnOffMsg: "Turn Off",
      onSpin: false,
      OffSpin: false,

      //overdrive
      ttlod: 0,
      active: false,
      active1: false,
      od_time_end: null,
      disabledDropDown: false,
      lockCount: 0,
      odrun: false,
      notAllowed: true,

      // For API usage
      clusterToken: "",
      clusterConn: "",
      totalopp: [],
      totalnotopp: 0,
      TotalLightOn: [],
      TotalLightOff: [],
      clusterID: null,
      roleScope: [],

      // Total Cost
      costTitle: "This Week Total Cost (MYR)",
      totalCost: "",
      costIcon: require("@/assets/img/Total Cost Icon.png"),

      // Total Energy
      energyTitle: "This Week Total Energy (kWh)",
      totalEnergy: "0",
      energyIcon: require("@/assets/img/Energy Icon.png"),

      // Operational Lights
      opLightsTitle: "Last Hour Operational Lights",
      operationalLights: "0",

      opLightsIcon: require("@/assets/img/Operational Light Icon.png"),

      // Cluster Status
      clusterStatusTitle: "Last Hour Cluster Status",
      clusterStatus: "",
      clusterStatusIcon: require("@/assets/img/Cluster Icon.png"),

      // Brightness Level
      clusterBrightnessTitle: "Last Hour Brightness Level",
      clusterBrightness: "",
      clusterBrightnessIcon: require("@/assets/img/Light Brightness.png"),
      clusterBrightnessShow: "",

      // Comm Uprate
      commUprateTitle: "Last Hour Communication Uprate",
      commUprate: "0",
      commUprateIcon: require("@/assets/img/Comm Uprate Icons.png"),

      //schedulerProfile
      schedulerProfileTitle: "Schedule Profile",
      schedulerProfile: "Not Available",
      schedulerData: [],
      schedulerProfileIcon: require("@/assets/img/Calendar Icon.png"),

      clusterName: "Not available",
      totalLight: 0,
      totalLux: 0,
      lastUpdate: {
        date: "Not available",
        range: "",
      },

      // Map's Attribute
      zoom: 18,
      center: L.latLng(3.15464, 101.718635),
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors ',
      markers: [],
      markerss: [],
      devBounds: [[2.921182, 101.636671]],
      // latLngBounds([[2.921182, 101.636671]]),
      largerview: [[2.921182, 101.636671]],
      fpmarkers: [],
      gwmarkers: [],
      fpmarkerss: [],
      gwmarkerss: [],
      luxmarkers: [],
      luxmarkerss: [],

      // Line Chart
      lineChart1: {
        chartData: {
          labels: [0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
      // Line Chart
      lineChart2: {
        chartData: {
          labels: [0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
      // Line Chart
      lineChart3: {
        chartData: {
          labels: [0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },

      selects: {
        simple: "",
        time: [
          { value: "30", label: "30 Min" },
          { value: "60", label: "60 Min" },
          { value: "1", label: "1 Min" },
        ],
        multiple: "ARS",
      },
      disabledBtn: true,
      // Pagination Table
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["deviceName"],
      tableColumns: [
        {
          prop: "deviceName",
          label: "Device Name",
          minWidth: 200,
        },
        {
          prop: "status",
          label: "Status",
          minWidth: 250,
        },
        {
          prop: "deviceID",
          label: "button",
          minWidth: 250,
        },
      ],
      logsData: [],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  created() {
    this.isLoading = true;
    let clusterid = this.$route.params.clusterid;
    this.clusterID = clusterid;

    //check override
    this.checkOverride();

    // get schedule profile
    this.getScheduleProfile();

    //get cluster details
    this.getClusterDetails(clusterid);

    let currentDate = moment().format("MMM Do");
    let defaultGraph = [];
    defaultGraph.push(currentDate);
    for (let i = 1; i < 7; i++) {
      let previousDate = moment().subtract(i, "days").format("MMM Do");
      defaultGraph.push(previousDate);
    }
   

    // let jwt_token = sessionStorage.getItem("token").split(".")[1];
    let jwt_token = this.$cookie.get("token").split(".")[1];
    jwt_token = JSON.parse(atob(jwt_token));
    let user_scope = jwt_token["UserScopes"];
    for (let i = 0; i < user_scope.length; i++) {
      this.roleScope.push(user_scope[i]);
    
      for (let j = 0; j < this.roleScope.length; j++) {
        if (
          this.roleScope[j] === "admin.control" ||
          this.roleScope[j] === "cluster.control"
        ) {
          this.disabledBtn = false;
          this.notAllowed = false;
          this.checkOverride();
        }
      }
    }
  },

  methods: {
    openlargermap() {
      this.markerss = this.markers;
      //       this.markers.map((c) => {
     
      //         this.largerview.push([c.location.lat, c.location.lng
      // ]);
      
      //       });

      this.fpmarkerss = this.fpmarkers;
      // this.fpmarkers.map((c) => {
      //   this.largerview.push([c.location.lat, c.location.lng]);
     
      // });

      this.gwmarkerss = this.gwmarkers;
      this.luxmarkerss = this.luxmarkers;
      //
      this.largerview = [];

  
      this.devBounds.map((c) => {
      
        this.largerview.push(c);
      });
      // this.fpmarkers.map((c) => {
      //   this.largerview.push([c.location.lat, c.location.lng]);
    
      // });

      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
        this.modals.viewlargermap = true;
      }, 100);

      setTimeout(() => {
        this.$refs.map.mapObject.invalidateSize();
      }, 100);
    },
    getScheduleProfile() {
   
      this.$http
        .get(":8002/api/v1/manage/cluster/" + this.clusterID)
        .then((res) => {
          if (!res.error) {
            // 1c78e836-06bf-43e9-60c6-eb0112d731a1
            let response = res.message;
          

            if (response.schedule_info.state == 1) {
              this.schedulerProfile = "Weekdays";
              this.schedulerData = response.schedule_info.weekdays;
            }
            if (response.schedule_info.state == 2) {
              this.schedulerProfile = "Weekends";
              this.schedulerData = response.schedule_info.weekends;
            }
            if (response.schedule_info.state == 3) {
              this.schedulerProfile = "Holiday";
              this.schedulerData = response.schedule_info.holiday;
            }
          }
        });
    },
    handleClusterOverride(min) {
      swal({
        title: "Are you sure?",
        text: `You want to edit override schedule to ${this.selects.simple} min`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.detectScheduler(min);
        } else {
          this.selects.simple = "";
        }
      });
    },
    renderCountDown() {
      this.test = setInterval(() => {
        if (this.od_time_end != "LUX_OD") {
          let testtime = moment.utc();
          let timenow = moment(testtime.format("HH:mm:ss"), "HH:mm:ss");
          let endtime = moment(this.od_time_end, "HH:mm:ss");
          let beza = endtime.diff(timenow);
         
          if (beza < 0) {
            this.active1 = false;
            this.disabledBtn = true;
            this.disabledDropDown = false;
            this.selects.simple = "";
            clearInterval();
          } else {
            this.overrideMsg =
              "Scheduler override is ongoing for " +
              this.odcountdown +
              " minutes";
            this.ttlod = moment.utc(beza).format("HH:mm:ss");
          }
        } else {
          this.overrideMsg = "Lux override";
        }
      }, 1000);
    },
    checkOverride() {
      if (!this.notAllowed) {
        var url = ":8004/api/v1/overdrive/" + this.clusterID + "";

        this.$http
          .get(url)
          .then((res) => {
            if (res.error) {
              swal({
                type: "error",
                title: "Oops... Something went wrong!",
                text: res.message,
              });
              this.message = res.message;
            } else {
              this.message = res.message;
            
              if (this.message.length > 0) {
                this.active1 = true;
                this.ttlod = res.message[0].od_time;
                this.disabledDropDown = true;
                this.disabledBtn = false;
                this.od_time_end = res.message[0].end_time;
                this.odrun = true;
                this.renderCountDown();
              } else {
                this.disabledBtn = true;
                this.disabledDropDown = false;
              }
            }
          })
          .catch((err) => {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: err,
            });
          });
      } else {
        this.disabledBtn = true;
        this.disabledDropDown = true;
      }
    },
    detectScheduler(min) {
    
      var url = ":8004/api/v1/overdrive/cluster/" + this.clusterID + "/" + min;

      this.$http
        .post(url)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          } else {
            this.message = res.message;
            swal({
              type: "success",
              title: "Changes Submitted!",
              text: res.message,
            });
            this.disabledDropDown = true;
            this.disabledBtn = false;
            this.odrun = true;
            this.checkOverride();
          }
          //
        })
        .catch((err) => {
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: err,
          });
        });
    },
    getClusterLogs() {
      var url = ":8007/api/v1/log/" + this.clusterID + "";

      this.$http.get(url).then((res) => {
        if (res.error) {
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: res.message,
          });
        } else {
         
          this.tableData = [];
          for (let i = 0; i < res.message.length; i++) {
           
            let obj = {};
            obj["eventtime"] = moment(res.message[i].createdAt).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            obj["context"] = res.message[i].LogContext;
            obj["message"] = res.message[i].LogMessage;
            this.tableData.push(obj);
          }
          this.modals.logs = true;
        }
        //
      });
    },
    viewDataAnalytic(d) {
      const clusterIDAnalytic = d;
    
      // this.$router.push({ name: `/dataanalyticcluster/${clusterIDAnalytic}` , params:{clusterinfo: this.clusterFullData} });
      this.$router.push({
        name: `Data Analytic Cluster`,
        params: { clusterinfo: this.clusterFullData },
      });
    },
    renderFP(device) {
     
      let payload = {
        device_list: device,
      };
      this.$http.get(":8002/api/v1/manage/feeder").then((res) => {
        if (res.error) {
        } else {
          
          // create map object
          res.message.map((c) => {
         
            let obj = {};
            obj["fploc"] = L.latLng(c.lat, c.lon);
            obj["fpname"] = c.fp_name;
            this.devBounds.push([c.lat, c.lon]);

            this.fpmarkers.push(obj);
          });

         
        }
      });
    },
    markerIcon(deviceStatus, lightStatus, type) {
      //notfollowschedule
     
      if (type == "DEVICE") {
        if (deviceStatus == 1) {
          if (lightStatus == 1) {
            return L.icon({
              iconSize: [30, 30], // size of the icon
              iconUrl: require("@/assets/img/light_online_on.png"),
              // iconUrl: require("@/assets/img/icon_on.png"),
              // iconSize: [30, 35], // size of the icon
              // shadowUrl: require("@/assets/img/marker-shadow.png"),
              iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
              // shadowAnchor: [30, 30], // the same for the shadow
              // shadowSize: [30, 30],
              popupAnchor: [-3, -76],
            });
          } else if (lightStatus == 3) {
            return L.icon({
              iconUrl: require("@/assets/img/light_online_notfollow.png"),
              iconSize: [30, 30], // size of the icon
              // iconUrl: require("@/assets/img/icon_on.png"),
              // iconSize: [30, 35], // size of the icon
              // shadowUrl: require("@/assets/img/marker-shadow.png"),
              iconAnchor: [22, 34], // point of the icon which will correspond to marker's location
              // shadowAnchor: [30, 30], // the same for the shadow
              // shadowSize: [30, 44],
              popupAnchor: [-3, -76],
            });
          } else {
            return L.icon({
              iconUrl: require("@/assets/img/light_online_off.png"),
              iconSize: [30, 30], // size of the icon
              // iconUrl: require("@/assets/img/icon_on.png"),
              // iconSize: [30, 35], // size of the icon
              // shadowUrl: require("@/assets/img/marker-shadow.png"),
              iconAnchor: [22, 34], // point of the icon which will correspond to marker's location
              // shadowAnchor: [30, 30], // the same for the shadow
              // shadowSize: [30, 44],
              popupAnchor: [-3, -76],
            });
          }
        } else {
          return L.icon({
            iconUrl: require("@/assets/img/light_offline.png"),
            iconSize: [30, 30], // size of the icon
            // iconUrl: require("@/assets/img/icon_off.png"),
            // iconSize: [30, 35], // size of the icon
            // shadowUrl: require("@/assets/img/marker-shadow.png"),
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            // shadowAnchor: [30, 30], // the same for the shadow
            // shadowSize: [30, 30],
            popupAnchor: [-3, -76],
          });
        }
      }
      if (type == "GATEWAY") {
        if (deviceStatus == "1") {
          return L.icon({
            iconUrl: require("@/assets/img/gw_online.png"),
            iconSize: [30, 30], // size of the icon
            // iconUrl: require("@/assets/img/icon_on.png"),
            // iconSize: [30, 35], // size of the icon
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            shadowAnchor: [30, 30], // the same for the shadow
            shadowSize: [30, 30],
            popupAnchor: [-3, -76],
          });
        } else {
          return L.icon({
            iconUrl: require("@/assets/img/gw_offline.png"),
            iconSize: [30, 30], // size of the icon
            // iconUrl: require("@/assets/img/icon_on.png"),
            // iconSize: [30, 35], // size of the icon
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            shadowAnchor: [30, 30], // the same for the shadow
            shadowSize: [30, 30],
            popupAnchor: [-3, -76],
          });
        }
      }

      if (type == "LUX") {
        if (deviceStatus == 1) {
          return L.icon({
            iconUrl: require("@/assets/img/LUX map icon online.png"),
            iconSize: [30, 30], // size of the icon
            // iconUrl: require("@/assets/img/icon_on.png"),
            // iconSize: [30, 35], // size of the icon
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            shadowAnchor: [30, 30], // the same for the shadow
            shadowSize: [30, 30],
            popupAnchor: [-3, -76],
          });
        } else {
          return L.icon({
            iconUrl: require("@/assets/img/lux map icon offline.png"),
            iconSize: [30, 30], // size of the icon
            // iconUrl: require("@/assets/img/icon_on.png"),
            // iconSize: [30, 35], // size of the icon
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            shadowAnchor: [30, 30], // the same for the shadow
            shadowSize: [30, 30],
            popupAnchor: [-3, -76],
          });
        }
      }
      // else if (type == "lux") {

      //     return L.icon({
      //       iconUrl: require("@/assets/img/gw_online.png"),
      //       iconSize: [30, 30], // size of the icon
      //       // iconUrl: require("@/assets/img/icon_on.png"),
      //       // iconSize: [30, 35], // size of the icon
      //       iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
      //       shadowAnchor: [30, 30], // the same for the shadow
      //       shadowSize: [30, 30],
      //       popupAnchor: [-3, -76],
      //     });

      // }
      if (type == "FEEDER") {
        return L.icon({
          iconUrl: require("@/assets/img/feeder_pillar.png"),
          iconSize: [30, 30], // size of the icon
          // iconUrl: require("@/assets/img/icon_on.png"),
          // iconSize: [30, 35], // size of the icon
          shadowUrl: require("@/assets/img/marker-shadow.png"),
          iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
          shadowAnchor: [30, 30], // the same for the shadow
          shadowSize: [30, 30],
          popupAnchor: [-3, -76],
        });
      }
    },
    LightControlNew(controlType, controlValue, clusterID) {
      var urlAPI = ":8003/api/v1/control/light/multicast/" + this.clusterToken;

      let value = controlType;

    

      if (controlType == "RTC") {
        let param = {
          conntype: this.clusterConn,
          context: "RTC",
          command: [
            {
              data: "1",
            },
          ],
        };

      

        this.$http.post(urlAPI, param).then((res) => {});
      } else {
        let param = {
          conntype: this.clusterConn,
          context: "CONTROL",
          command: [
            {
              data: controlValue,
            },
          ],
        };

      

        localStorage.setItem("lastcmd", controlValue);

        this.getClusterDevice(false);

        this.$http.post(urlAPI, param).then((res) => {});
      }
    },
    LightControl(controlType, controlValue, clusterID) {
      var urlAPI =
        ":8003/v1/api/control/light/multicast/" +
        clusterID +
        "/" +
        this.clusterID;

      var param = "";
      if (controlType == "POWER") {
        param = controlValue;

        if (param == "AQABBQ==") {
          //if on
          
          this.btnOnMsg = "Loading..";
          this.onSpin = true;
          this.disabledBtn = true;
          setTimeout(() => {
            this.btnOnMsg = "Turn On";
            this.onSpin = false;
            this.disabledBtn = false;
          }, 3000);
          this.lastCommandSend = param;
        } else if (param == "AQAABQ==") {
          //if off
       
          this.btnOffMsg = "Loading..";
          this.OffSpin = true;
          this.disabledBtn = true;
          setTimeout(() => {
            this.btnOffMsg = "Turn Off";
            this.OffSpin = false;
            this.disabledBtn = false;
          }, 3000);
          this.lastCommandSend = param;
        }
      } else if (controlType == "BRIGHTNESS") {
        switch (controlValue) {
          case "10.00":
            param = "AQABAQ==";
            break;
          case "20.00":
            param = "AQABAg==";
            break;
          case "30.00":
            param = "AQABAw==";
            break;
          case "40.00":
            param = "AQABBA==";
            break;
          case "50.00":
            param = "AQABBQ==";
            break;
          case "60.00":
            param = "AQABBg==";
            break;
          case "70.00":
            param = "AQABBw==";
            break;
          case "80.00":
            param = "AQABCA==";
            break;
          case "90.00":
            param = "AQABCQ==";
            break;
          case "100.00":
            param = "AQABCg==";
            break;
          default:
        }
      }

      let data = [
        {
          multicastQueueItem: {
            confirmed: false,
            fPort: 3,
            devEUI: "",
            data: param,
          },
        },
      ];
      
      this.$http.post(urlAPI, data).then((res) => {});
    },
    viewDevice(devid, flag, devtoken) {
      const deviceid = devid;
      // this.$router.push({ path: `/light/${deviceid}` });
     
      if (flag == "nodestl") {
        const deviceid = devid;
        this.$router.push({ path: `/light/${deviceid}` });
      }

      if (flag == "lux") {
    
        // let start = moment().subtract(24, "hours").unix();
        // let end = moment().unix();
        
        const deviceid = devid;
        this.$router.push("/lux/" + deviceid + "/" + devtoken);
      }
    },
    get30Min() {
      const timeNow = moment();
      let timeMinNow = timeNow.minute();
      const remainder = 30 - (timeMinNow % 30);
     
      if (timeMinNow > 30) {
        return moment(timeNow)
          .add(-remainder, "minutes")
          .format("DD-MM-YYYY h:mm a");
      } else {
        return (
          moment(timeNow)
            .add(remainder + -60, "minutes")
            // .add(-remainder, "minutes")
            .format("DD-MM-YYYY h:mm a")
        );
      }
    },
    getClusterDevice(modalstate) {
      let token = [];
      this.devBounds = [];
    
      this.$http
        .get(":8002/api/v1/manage/cluster/device/" + this.clusterID)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
            let data = [];
            let lux = [];
            for (var k = 0; k < res.message.device_list.length; k++) {
              if (res.message.device_list[k].devicetype == "nodestl") {
                data.push(res.message.device_list[k]);
              } else {
                lux.push(res.message.device_list[k]);
              }
            }
            // let data = res.message.device_list;
          

            this.totalLight = data.length; // Get total lights in the cluster
            this.totalLux = lux.length;
            // this.center = L.latLng(data[0].lat, data[0].lon); // Center the marker using lat/long of first light
            this.renderFP(res.message.device_list);

            // for (let i = 0; i < data.length; i++) {
            //   token.push(data[i].devicetoken);
            // }
            let _operationalLights = this.calculateUptime(data);
            let _operationalLux = this.calculateUptime2(lux);
           

            Promise.all(_operationalLights).then((res) => {
              
              let a = res[0];
              this.markers = [];
              this.tableData = [];
             
              for (let i = 0; i < a.length; i++) {
                let obj = {};

            

                obj["location"] = L.latLng(a[i].lat, a[i].lon);
                obj["flag"] = a[i].flag;
                obj["deviceName"] = a[i].deviceName;
                obj["deviceID"] = a[i].deviceID;
                obj["deviceToken"] = a[i].deviceToken;
                obj["status"] = a[i].status;
                obj["operationalStat"] = a[i].operationalStat;

                let lightData = {};
                lightData["deviceName"] = a[i].deviceName;
                lightData["status"] =
                  a[i].operationalStat === 1 ? "Online" : "Offline";
                lightData["deviceID"] = a[i].deviceID;
                this.devBounds.push([a[i].lat, a[i].lon]);

                this.markers.push(obj);
                this.tableData.push(lightData);
                // this.queriedData.push(lightData)
              }
             
              if (modalstate) {
                this.modals.lights = true;
              }
              this.isLoading = false;
            });

            Promise.all(_operationalLux).then((res) => {
             
              let a = res[0];
              this.luxmarkers = [];
              // this.tableData = [];
              
              for (let i = 0; i < a.length; i++) {
                let obj = {};

               

                obj["location"] = L.latLng(a[i].lat, a[i].lon);
                obj["flag"] = a[i].flag;
                obj["deviceName"] = a[i].deviceName;
                obj["deviceID"] = a[i].deviceID;
                obj["deviceToken"] = a[i].deviceToken;

                let start = moment.unix(a[i].timestamp);
                let end = moment();
             

                var duration = end.diff(start, "hours");
               

                obj["status"] = duration <= 1 ? "1" : "0";
                // obj["operationalStat"] = a[i].operationalStat;

                let lightData = {};
                lightData["deviceName"] = a[i].deviceName;
                // lightData["status"] =
                //   a[i].operationalStat === 1 ? "Online" : "Offline";
                lightData["deviceID"] = a[i].deviceID;
                this.devBounds.push([a[i].lat, a[i].lon]);

                this.luxmarkers.push(obj);
                // this.tableData.push(lightData);
                // this.queriedData.push(lightData)
              }
             
              if (modalstate) {
                this.modals.lights = true;
              }
              this.isLoading = false;
            });
          }
        })
        .catch((err) => {});
    },
    getData(data) {
     
      let tariff = 0;
      let watt = 0;
      let totalDevice = data.device_list.length;
      let sumTotalEnergy = 0;
      let sumTotalCost = 0;

      data.cluster_attribute.map((i) => {
        i.key === "CLUSTER_TARIFF_RATE" ? (tariff = parseFloat(i.value)) : 0;

        i.key == "CLUSTER_LIGHTS_WATT" ? (watt = parseInt(i.value, 10)) : 0;
      });

      var endDate = moment().add(1, "days");
      var startDate = moment().subtract(6, "days");

      var dates = [];

      while (startDate.format("M/D/YYYY") !== endDate.format("M/D/YYYY")) {
       
        dates.push(startDate.toDate());
        startDate = startDate.add(1, "days");
      }

      let countWeekdays = 0;
      let countWeekends = 0;
      
      for (var i = 0; i < dates.length; i++) {
      
        if (
          moment(dates[i]).format("ddd").toString() == "Sat" ||
          moment(dates[i]).format("ddd").toString() == "Sun"
        ) {
          countWeekends++;
        }

        if (
          moment(dates[i]).format("ddd").toString() != "Sat" &&
          moment(dates[i]).format("ddd").toString() != "Sun"
        ) {
          countWeekdays++;
        }
      }
     

      // Calculate energy for weekdays
      let scheduleListWeekday = data.schedule_info.weekdays;

      let sumEnergyForWeekday = 0;
     

      //ITERATE EACH GET ENERGY TOTAL FOR DAY FOR WEEKDAYS
      for (let i = 0; i < scheduleListWeekday.length; i++) {
        if (i + 1 != scheduleListWeekday.length) {
          //GET WATT
         
          let w =
            watt *
            ((parseInt(scheduleListWeekday[i].slice(12, 14), 16) * 10) / 100);

          //GET RUNNING TIME
          let time1 = moment(
            parseInt(scheduleListWeekday[i].slice(6, 8), 16).toString() +
              ":" +
              parseInt(scheduleListWeekday[i].slice(8, 10), 16).toString(),
            "HH:mm"
          );
          let time2 = moment(
            parseInt(scheduleListWeekday[i + 1].slice(6, 8), 16).toString() +
              ":" +
              parseInt(scheduleListWeekday[i + 1].slice(8, 10), 16).toString(),
            "HH:mm"
          );
          let duration = moment.duration(time2.diff(time1));
          let runningHour = parseInt(duration.asHours());

          //GET ENERGY
          if (i == 5) {
            runningHour = 1;
          }
          sumEnergyForWeekday += (w * runningHour) / 1000;
        }
      }

      

      // Calculate energy for weekend
      let scheduleListWeekend = data.schedule_info.weekends;

      let sumEnergyForWeekend = 0;
    

      //ITERATE EACH GET ENERGY TOTAL FOR DAY FOR WEEKDAYS
      for (let i = 0; i < scheduleListWeekend.length; i++) {
        if (i + 1 != scheduleListWeekend.length) {
          //GET WATT
          
          let w =
            watt *
            ((parseInt(scheduleListWeekend[i].slice(12, 14), 16) * 10) / 100);

          //GET RUNNING TIME
          let time1 = moment(
            parseInt(scheduleListWeekend[i].slice(6, 8), 16).toString() +
              ":" +
              parseInt(scheduleListWeekend[i].slice(8, 10), 16).toString(),
            "HH:mm"
          );
          let time2 = moment(
            parseInt(scheduleListWeekend[i + 1].slice(6, 8), 16).toString() +
              ":" +
              parseInt(scheduleListWeekend[i + 1].slice(8, 10), 16).toString(),
            "HH:mm"
          );
          let duration = moment.duration(time2.diff(time1));
          let runningHour = parseInt(duration.asHours());

          //GET ENERGY
          if (i == 5) {
            runningHour = 1;
          }
          sumEnergyForWeekend += (w * runningHour) / 1000;
        }
      }

     

      // total energy ((total weekday * sumEnergyWeekday) + (total weekend * sumEnergyWeekend)) * total device
      this.totalEnergy = (
        (countWeekdays * sumEnergyForWeekday +
          countWeekends * sumEnergyForWeekend) *
        totalDevice
      ).toFixed(2);

      // total cost (((total weekday * sumEnergyWeekday) + (total weekend * sumEnergyWeekend))* tariff) * total device
      this.totalCost = (
        (countWeekdays * sumEnergyForWeekday +
          countWeekends * sumEnergyForWeekend) *
        tariff *
        totalDevice
      ).toFixed(2);
    },
    getChartData(data) {
    
      // assign chart label

      // calculate voltage for pass 7 days
      let voltage = [240, 240, 240, 240, 240, 240, 240];

      // calculate energy for pass 7 days

      // this.initLine1("voltage", res.message.cluster_data);
      // this.initLine1("current", res.message.cluster_data);
      // this.initLine1("energy", res.message.cluster_data);
    },
    getClusterDetails(clusterid) {
      
      this.$http
        .get(":8002/api/v1/manage/cluster/" + clusterid)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
            this.clusterFullData = res.message.cluster_info;
           
            //cluster attribute
          

            this.getData(res.message);
            // this.getChartData(res.message);

            res.message.cluster_attribute.map((i) => {
              i.key === "CLUSTER_TARIFF_RATE"
                ? (this.clusterTariff = parseFloat(i.value))
                : 0;

              i.key == "CLUSTER_OLD_SON"
                ? (this.clusterOldSon = parseInt(i.value, 10))
                : 0;
            });

            data = res.message;
            //schedule info
            if (data.schedule_info.state == "1") {
              data.schedule_info.weekdays.map((i) => {
                
                parseInt(i.slice(10, 12), 16) === 1 ? this.totalLightOn++ : 0;
              });
            } else if (data.schedule_info.state == "2") {
              data.schedule_info.weekends.map((i) => {
                parseInt(i.slice(10, 12), 16) === 1 ? this.totalLightOn++ : 0;
              });
            } else if (data.schedule_info.state == "3") {
              data.schedule_info.holidays.map((i) => {
                parseInt(i.slice(10, 12), 16) === 1 ? this.totalLightOn++ : 0;
              });
            }

            //cluster info

            let data = this.clusterFullData;
            
            this.clusterName = data.clustername;
            this.clusterToken = data.multicastid;
            this.clusterConn = data.conntype;
            this.getGatewayList();
            this.getClusterData(clusterid);
            this.getClusterDevice(false);
          }
        })
        .catch((err) => {});
    },
    checkClusterStatus(status) {
      let totalon = [];
      if (status.length < 0 || status.length == null) {
        this.clusterStatus = "Not Available";
      } else {
        for (let i = 0; i < status.length; i++) {
          let stat = JSON.parse(JSON.parse(status[i].value));
          totalon.push(stat.status);
        }

        

        let onz =
          totalon.reduce((ttl, skrg) => {
            skrg == 1 ? (ttl += 1) : ttl;
            return ttl;
          }, 0) / totalon.length;

        //if less then 10% average daily cluster status ON , consider cluster offline
        let cent = (onz * 100).toFixed(1);
        cent < 10
          ? (this.clusterStatus = "Offline")
          : (this.clusterStatus = "Online");
      }
    },
    calculateBrightnessAVG(data) {
    
      if (data == 0) {
        this.clusterBrightnessShow = data.toString() + "%";
      }
      let all_brightness = [];

      for (let i = 0; i < data.length; i++) {
    
        let val = 0;
        if (data[i].status == "1") {
          val = data[i].brightness;
        } else {
          val = 0;
        }
        all_brightness.push(parseInt(val));
      }

      let avg = all_brightness.reduce((a, b) => a + b, 0) / data.length;
     
      this.clusterBrightnessShow = avg.toFixed(2).toString() + "%";
    },
    getClusterData(clusterid) {
      let today = moment().unix();
      let later = moment().subtract(8, "days").unix();
      // let today = moment().subtract(1, "days").format("YYYY-MM-DD");
      // let later = moment().subtract(8, "days").format("YYYY-MM-DD");
      // var endDate = moment()
      // var startDate = moment().subtract(7, "days");
   
      // let startOfWeek = moment().startOf("isoWeek").unix();
      // let startOfWeek = moment().subtract(1, 'days').unix()

      this.$http
        .get(
          ":8001/api/v1/telemetry/cluster/" +
            clusterid +
            "/" +
            later +
            "/" +
            today +
            ""
        )
        .then((res) => {
          if (res.message.cluster_data == null) {
            this.resetChart("voltage");
            this.resetChart("current");
            this.resetChart("energy");
            this.checkClusterStatus(0);
            // this.calculateBrightnessAVG(0);
            return;
          } else {
            // this.clusterStatus = "Checking...";
            // this.operationalLights = "Checking...";
            // this.commUprate = "Checking...";
            let clusterData = JSON.parse(
              JSON.parse(res.message.cluster_data[0].value)
            );

          

            let clsuterBright = clusterData.dimm * 10;
            // this.clusterBrightnessShow = clsuterBright.toString() + ".00%";
            // this.checkClusterStatus(res.message.cluster_data);
            // this.calculateBrightnessAVG(res.message.cluster_data);
           

            this.initLine1("voltage", res.message.cluster_data);
            this.initLine1("current", res.message.cluster_data);
            this.initLine1("energy", res.message.cluster_data);

            //Get gateway
            this.getGatewayList();
          }
        });
    },
    getCurrentLightState(state, lastActS, lastHrTS) {
      
      let schedule = this.schedulerData;
      let status = "0";
      if (!this.odrun) {
        //get current time
        // let timeNow = moment().utc();

        let timeNow = moment.unix(lastHrTS);
       
        for (let i = 0; i < schedule.length; i++) {
          let startONHour = parseInt(
            schedule[i].substring(6, 8),
            16
          ).toString();
          let startONMin = parseInt(
            schedule[i].substring(8, 10),
            16
          ).toString();
        
          let timeSchedule = moment(startONHour + ":" + startONMin, "HH:mm A");

          if (timeNow.hour().toString() == startONHour) {
           
            status = schedule[i].substring(10, 12);
            status = parseInt(status).toString();
            // if (timeNow.isAfter(timeSchedule)) {
            //   status = schedule[i].substring(10, 12);
            //   status = parseInt(status).toString();
            
            // } else {

            //   if (i - 1 != -1) {
            //     status = schedule[i - 1].substring(10, 12);
            //     status = parseInt(status).toString();
            //   } else {
           
            //     status = schedule[0].substring(10, 12);
            //   }
            // }

            break;
          } else {
            status = 0;
          }
        }

       
        // schedule.map((a, i) => {

        //       });

       
        if (status != state) {
          status = "3";
        }

       
        let startON = schedule[0].substring(6, 8);
        let startONHour = schedule[0].substring(6, 8);
        let startONMin = schedule[0].substring(7, 9);
        let startOFF = schedule[schedule.length - 1].substring(6, 8);

        

        //CHECK NOW ON OR OFF
        // if (timeNow.hour() >= parseInt(startON, 16)) {
        //   status = "1";
        // } else {
        //   status = "0";
        // }

       
      } else {
        //get last command
        let lastcmd = localStorage.getItem("lastcmd");

        if (lastcmd == "OFF" || lastcmd == "") {
          status = "0";
        } else {
          status = "1";
        }
      }

      return status;
    },
    calculateUptime(id) {
      
      let promises = [];
      let oop = [];
      this.totalopp = [];
      let count = 0;
      let d = 0;
      let t;
      let payload = {
        devicelist: [],
      };

      id.map((i) => {
        payload.devicelist.push(i.devicetoken);
      });

      
      this.clusterStatus = "Checking...";
      this.operationalLights = "Checking...";
      promises.push(
        this.$http
          .post(
            ":8001/api/v1/telemetry/device/status/beta/lights?cluster_id=" +
              this.clusterID,
            payload
          )
          .then((res) => {
            if (res.error) {
             
            } else {
             
              this.calculateBrightnessAVG(res.message);
              for (let i = 0; i < id.length; i++) {
               
                if (res.message[i].deviceid == id[i].devicetoken) {
                 
                  if (res.message[i].timestamp == "0") {
                    res.message[i].timestamp = res.message[i].last_tx_hourly;
                  }
                
                  if (res.message[i].timestamp == "0") {
                    let obj = {};
                    obj["deviceToken"] = id[i].devicetoken;
                    obj["deviceName"] = id[i].devicename;
                    obj["deviceID"] = id[i].deviceid;
                    obj["lat"] = id[i].lat;
                    obj["lon"] = id[i].lon;
                    obj["operationalStat"] = 0;
                    obj["status"] = 0;
                    obj["flag"] = id[i].devicetype;

                    oop.push(obj);
                  } else {
                    let a = moment(moment(), "hh:mm:ss");
                    let b = moment(
                      moment.unix(res.message[i].timestamp),
                      "hh:mm:ss"
                    );

                    let c = a.diff(b, "hours");
                    // let c = 0;
               
                    //Calculate Uprate
                    // this.totalopp.push(1)
                    //CHECK TOTAL ON OFF STATUS

                    //TOTAL OPERATION LIGHT
                    c < 3 ? this.totalopp.push(1) : this.totalnotopp++;
                    let obj = {};
                   
                    obj["deviceToken"] = id[i].devicetoken;
                    obj["deviceName"] = id[i].devicename;
                    obj["deviceID"] = id[i].deviceid;
                    obj["status"] = res.message[i].status;
                    obj["flag"] = id[i].devicetype;
                    // obj["status"] = this.getCurrentLightState(
                    //   res.message[i].status,
                    //   res.message[i].timestamp,
                    //   res.message[i].last_tx_hourly
                    // );
                    obj["lat"] = id[i].lat;
                    obj["lon"] = id[i].lon;
                    // obj["location"] = L.latLng(id[i].lat, id[i].lon);.
                    // obj["operationalStat"] = 1
                    c < 3
                      ? (obj["operationalStat"] = 1)
                      : (obj["operationalStat"] = 0);
                    oop.push(obj);
                    this.tempMarker.push(obj);
                  }

                  res.message[i].status == 0
                    ? this.TotalLightOff.push(1)
                    : this.TotalLightOn.push(1);
                }
              }
            
              return oop;
            }
          })
      );

      Promise.all(promises).then((res) => {
        this.operationalLights = 0;
        this.commUprate = 0 + "%";

        let commUprateValue = (this.totalopp.length / this.totalLight) * 100;
        this.operationalLights = this.totalopp.length.toString();
        this.commUprate = commUprateValue.toFixed(2) + "%";
        if (commUprateValue.toFixed(2) > 0) {
          this.clusterStatus = "Online";
        } else {
          this.clusterStatus = "Offline";
        }
      });

      return promises;
    },
    calculateUptime2(id) {
    
      let promises = [];
      let oop = [];
      // this.totalopp = [];
      let count = 0;
      let d = 0;
      let t;
      let payload = {
        devicelist: [],
      };

      id.map((i) => {
        payload.devicelist.push(i.devicetoken);
      });
      
      // this.clusterStatus = "Checking...";
      // this.operationalLights = "Checking...";
      promises.push(
        this.$http
          .post(":8001/api/v1/telemetry/device/status/beta/lux", payload)
          .then((res) => {
            if (res.error) {
           
            } else {
              // this.calculateBrightnessAVG(res.message);
          
              for (let i = 0; i < id.length; i++) {
           
                if (res.message[i].deviceid == id[i].devicetoken) {
             
                  if (res.message[i].timestamp == "0") {
                    res.message[i].timestamp = res.message[i].last_tx_hourly;
                  }
                
                  if (res.message[i].timestamp == "0") {
                    let obj = {};
                    obj["deviceToken"] = id[i].devicetoken;
                    obj["deviceName"] = id[i].devicename;
                    obj["deviceID"] = id[i].deviceid;
                    obj["lat"] = id[i].lat;
                    obj["lon"] = id[i].lon;
                    obj["operationalStat"] = 0;
                    obj["status"] = 0;
                    obj["flag"] = id[i].devicetype;
                    obj["timestamp"] = res.message[i].timestamp;

                    oop.push(obj);
                  } else {
                    // let a = moment(moment(), "hh:mm:ss");
                    // let b = moment(
                    //   moment.unix(res.message[i].timestamp),
                    //   "hh:mm:ss"
                    // );

                    // let c = a.diff(b, "hours");
                    // let c = 0;
                  
                    //Calculate Uprate
                    // this.totalopp.push(1)
                    //CHECK TOTAL ON OFF STATUS

                    //TOTAL OPERATION LIGHT
                    // c < 3 ? this.totalopp.push(1) : this.totalnotopp++;
                    let obj = {};
                 
                    obj["deviceToken"] = id[i].devicetoken;
                    obj["deviceName"] = id[i].devicename;
                    obj["deviceID"] = id[i].deviceid;
                    obj["status"] = res.message[i].status;
                    obj["flag"] = id[i].devicetype;
                    obj["timestamp"] = res.message[i].timestamp;
                    // obj["status"] = this.getCurrentLightState(
                    //   res.message[i].status,
                    //   res.message[i].timestamp,
                    //   res.message[i].last_tx_hourly
                    // );
                    obj["lat"] = id[i].lat;
                    obj["lon"] = id[i].lon;
                    // obj["location"] = L.latLng(id[i].lat, id[i].lon);.
                    // obj["operationalStat"] = 1
                    // c < 3
                    //   ? (obj["operationalStat"] = 1)
                    //   : (obj["operationalStat"] = 0);
                    oop.push(obj);
                    // this.tempMarker.push(obj);
                  }

                  // res.message[i].status == 0
                  //   ? this.TotalLightOff.push(1)
                  //   : this.TotalLightOn.push(1);
                }
              }
            
              return oop;
            }
          })
      );

      Promise.all(promises).then((res) => {
        // this.operationalLights = 0;
        // this.commUprate = 0 + "%";
        // let commUprateValue = (this.totalopp.length / this.totalLight) * 100;
        // this.operationalLights = this.totalopp.length.toString();
        // this.commUprate = commUprateValue.toFixed(2) + "%";
        // if (commUprateValue.toFixed(2) > 0) {
        //   this.clusterStatus = "Online";
        // } else {
        //   this.clusterStatus = "Offline";
        // }
      });

      return promises;
    },
    getGatewayList() {
      //GET ALL GATEWAY LIST
      this.GatewayOnlineCount = 0;
      this.GatewayOfflineCount = 0;
      this.$http.get(":8003/api/v1/gateway").then((res) => {
       
        res.message.map((a) => {
         
          if (a.deleteAt == null) {
            let obj = {};
            obj["gwloc"] = L.latLng(a.lat, a.lon);
            obj["gwname"] = a.GatewayName;
            obj["status"] = a.Status;
            this.devBounds.push([a.lat, a.lon]);
            if (a.Status == "1") {
              // online count
              this.GatewayOnlineCount++;
            } else {
              // offline count
              this.GatewayOfflineCount++;
            }
            this.gwmarkers.push(obj);
          }
        });
      });
    },

    initLine1(param, data) {
     
      let avr = 0;
      let clusdata = null;
      let date = null;
      let timeStamp = [];
      let dataValue = [];

      // chart label
      // var endDate = moment().add(1, "days");
      var endDate = moment();
      var startDate = moment().subtract(7, "days");

      var dates = [];
      var end = moment();
      var start = moment().subtract(7, "days");

      // for chart label
      while (start.format("M/D/YYYY") !== end.format("M/D/YYYY")) {
        dates.push(moment(start).format("MMM Do YY"));
        start = start.add(1, "days");
      }

      while (startDate.format("M/D/YYYY") !== endDate.format("M/D/YYYY")) {
        timeStamp.push(moment(startDate).format("MMM Do YY"));
        startDate = startDate.add(1, "days");
      }
   

      // INITIALIZE THE DATE FOR ARRAY OF CURRENT WEEK (X-AXIS)
      // let startOfWeek = moment().startOf("isoWeek").format("MMM Do YY");

      // for (let i = 0; i < 7; i++) {
      //   timeStamp.push(startOfWeek);
      //   startOfWeek = moment(startOfWeek, "MMM Do YY")
      //     .add(1, "days")
      //     .format("MMM Do YY");
      // }

      /////////////////////////////////////////////////////////
     
      // INITIALIZE DATA VALUE UNTIL CURRENT DAY OF WEEK WITH 0

      for (let i = 0; i < timeStamp.length; i++) {
       
        dataValue.push(0);
      }
      /////////////////////////////////////////////////////////
    
      for (let i = 0; i < data.length; i++) {
        clusdata = JSON.parse(JSON.parse(data[i].value));
       

        date = data[i].timestamp;
        // dlm unix
       

        for (let j = 0; j < timeStamp.length; j++) {
       
          //  dlm date
   

       
          if (param == "voltage") {
            if (
              moment.unix(data[i].timestamp).format("MMM Do YY") == timeStamp[j]
            ) {
             
              dataValue[j] += clusdata.voltage; //y-axis clusdata.voltage
            }
          } else if (param == "current") {
         
            if (
              moment.unix(data[i].timestamp).format("MMM Do YY") == timeStamp[j]
            ) {
            
              // dataValue[j] += (clusdata.current) / 1000 ; //y-axis
           
              //   clusdata.energy / this.totalLightOn / clusdata.voltage
              // );
           

              dataValue[j] += (
                clusdata.energy /
                this.totalLightOn /
                clusdata.voltage
              ).toFixed(2); //y-axis
            }
           
          } else if (param == "energy") {
            if (
              moment.unix(data[i].timestamp).format("MMM Do YY") == timeStamp[j]
            ) {
            
              dataValue[j] = clusdata.energy / 1000; //y-axis
             
            }
          }

         
        }
      }

    

      //last cluster update
      this.lastUpdate.date = moment
        .unix(date)
        .local()
        .format("DD-MM-YYYY h:mm:ss a");
      this.lastUpdate.range = moment.unix(date).fromNow();

      let chart = {
        chartData: {
          labels: timeStamp,
          datasets: [
            {
              label: "Weekly " + param,
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: dataValue,
            },
          ],
        },
        extraOptions: chartConfigs.energyChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };

      if (param == "voltage") {
        this.lineChart1 = chart;
      } else if (param == "current") {
        this.lineChart2 = chart;
     
      } else if (param == "energy") {
        //total energy
        let _totalEnergy = dataValue.reduce((a, b) => a + b, 0).toFixed(2);

        // this.totalCost = (
        //   parseFloat(_totalEnergy) * this.clusterTariff
        // ).toFixed(2);

        // hmm
        // this.totalEnergy = _totalEnergy.toString();
        this.lineChart3 = chart;
      }
    },
    resetChart(param) {
      let timeStamp = [];
      let startOfWeek = moment().startOf("isoWeek").format("MMM Do YY");

      for (let i = 0; i < 7; i++) {
        timeStamp.push(startOfWeek);
        startOfWeek = moment(startOfWeek, "MMM Do YY")
          .add(1, "days")
          .format("MMM Do YY");
      }

      let chart = {
        chartData: {
          labels: timeStamp,
          datasets: [
            {
              label: "Weekly " + param,
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };

      if (param == "voltage") {
        this.lineChart1 = chart;
      } else if (param == "current") {
        this.lineChart2 = chart;
      } else if (param == "energy") {
        this.lineChart3 = chart;
      }
    },
  },
  computed: {
    odcountdown() {
      let self = this;

      if (this.active1) {
        this.renderCountDown();
      } else {
        clearInterval();
      }
      return this.ttlod;
    },

    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  mounted() {
    //Pulldata
    // this.interval = setInterval(() => {
    //   this.getClusterDevice(false);
    // }, 60000);
    // Fuse search initialization.
    // Get token to check for role scope of user
  },

  watch: {
    clusterBrightness() {
      let self = this;
      clearTimeout(this.test);
    
      if (this.lockCount === 0) {
       
        this.lockCount = 1;
      } else {
        if (this.clusterBrightness !== "") {
          clearTimeout(this.test);
          this.test = setTimeout(() => {
            let value = this.clusterBrightness;
          
            this.LightControlNew(
              "BRIGHTNESS",
              parseInt(value, 10).toString(),
              this.clusterToken
            );
          }, 5000);
        }
      }
    },
    searchQuery(value) {
      let result = this.tableData;
      let fuseSearch = new Fuse(this.tableData, {
        keys: ["deviceName"],
        threshold: 1.0,
      });
      if (value !== "") {
        result = fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    markers: {
      handler: function (val, oldVal) {
      
        this.countonlineoff = 0;
        this.countonlineon = 0;
        this.countoffline11 = 0;

        for (var i = 0; i < this.markers.length; i++) {
          // this.count++
        
          if (this.markers[i].operationalStat == 1) {
            if (parseInt(this.markers[i].status) == 0) {
              this.countonlineoff++;
            }
            if (parseInt(this.markers[i].status) == 1) {
              this.countonlineon++;
            }
            if (
              parseInt(this.markers[i].status) >= 2 &&
              parseInt(this.markers[i].status) <= 11
            ) {
              this.countoffline11++;
              //   this.countoffline2to9++
             
              // }
              // if (parseInt(this.markers[i].status) == 10 ) {
              //   this.countoffline10++
          
              // }
              // if (parseInt(this.markers[i].status) == 11 ) {
              //   this.countoffline11++
            
            }
          }

          if (this.markers[i].operationalStat == 0) {
            this.countoffline11++;
            if (
              parseInt(this.markers[i].status) >= 2 &&
              parseInt(this.markers[i].status) <= 11
            ) {
              //   this.countoffline2to9++
             
              // }
              // if (parseInt(this.markers[i].status) == 10 ) {
              //   this.countoffline10++
           
              // }
              // if (parseInt(this.markers[i].status) == 11 ) {
              //   this.countoffline11++
            
              // }
              // if(parseInt(this.markers[i].status) == 0){
           
              //   this.countoffline11++
            }
          }
        
          // if (
          //   parseInt(this.markers[i].status) >= 2 &&
          //   parseInt(this.markers[i].status <= 9)
          // ) {

          // }
        }

        
      },
      deep: true,
    },
    // markers: {
    //   handler: function (val, oldVal) {
    //    this.markerss = this.markers
    //   },
    //   deep: true
    // },
    // fpmarkers: {
    //   handler: function (val, oldVal) {
    //    this.fpmarkerss = this.fpmarkers
    //   },
    //   deep: true
    // },
    // gwmarkers: {
    //   handler: function (val, oldVal) {
    //    this.gwmarkerss = this.gwmarkers
    //   },
    //   deep: true
    // }
  },
};
</script>

<style scoped>
.analytic el-select {
  display: inline;
}
.il h3 {
  display: inline;
  color: #6f7077;
  font-weight: 400;
}
hr {
  background-color: #64b983;
  margin-top: 5px;
  padding-bottom: 2px;
}
#legend {
  background: #fff;
  margin: 12px;
  color: rgb(86, 86, 86);
  background-color: rgb(255, 255, 255);
  padding: 10px;
  border-radius: 2px;
  background-clip: padding-box;
  box-shadow: 0px 1px 4px -1px rgba(0, 0, 0, 0.3);
}
.legend_attr {
  padding-top: 3px;
}
</style>
